import * as core from "@lts/core/Legacy/legacy";

export { core };
export default core;
